<template>
    <div class="main-page">
        <IFrameSingleEvent
            :event="eventData"
            i-frame-type="events"
            :loading="loading" />
        <div class="flex-grow-1" />
        <div class="mx-2 mt-6 mb-4 d-flex gap-4 justify-content-end">
            <a
                v-if="impressumLink"
                :href="impressumLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Impressum</a>
            <a
                v-if="privacyLink"
                :href="privacyLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Datenschutz</a>
        </div>
    </div>
</template>

<script>


export default {
    name: "EventId",
    validate({params}) {
        // Must be a number
        return /^\d+$/.test(params.id)
    },
    provide() {
        return {
            iFrameType: () => "events"
        }
    },
    data() {
        return {
            eventData: null,
            loading: true
        }
    },
    computed: {
        eventId() {
            return parseInt(this.$route.params.id)
        },
        impressumLink() {
            return this.sanitizeLink(this.eventData?.organizer?.urlImpressum ?? null)
        },
        privacyLink() {
            return this.sanitizeLink(this.eventData?.organizer?.urlPrivacy ?? null)
        }
    },
    methods: {
        async fetch() {
            this.loading = true
            try {
                this.eventData = (await this.$axios.get(this.$apiRoute('api.events.show', {event: this.eventId})))?.data?.data
            } catch (e) {
                console.error(e)
            }
            this.loading = false
        },
        sanitizeLink(link) {
            if (!link) return null
            if (link.startsWith('http')) return link
            return '//' + link
        }
    },
    mounted() {
        this.fetch()
    }
}
</script>

<style>
.main-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
</style>
